import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { createClient } from "contentful";

// components
import Button from "../button/Button";

// images
import adharvaLogo from "../../images/adharva_logo.png";

// constants
import { NAVIGATION_LINKS, NAVIGATION_BAR_BUTTON } from "./NavigationConstants";

// styled
import "./NavigationBar.css";
import * as S from "./NavBarStyledComponents"

export const NavigationBar = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [showNavBarColor, setShowNavBarColor] = useState(false)
  const currentTabRef = useRef();
  const previousTabRef = useRef();

  const [navigationData, setNavigationBarData] = useState({});
  const client = createClient({
    space: process.env.REACT_APP_CLIENT_SPACE_ID,
    accessToken: process.env.REACT_APP_CLIENT_ACCESS_TOKEN,
  });

  const handleClick = () => setClick(!click);
  const closeMobileMenu = (ref) => {
    if (previousTabRef.target) {
      previousTabRef.target.classList.remove("nav-links-clicked");
    }
    ref.target.classList.add("nav-links-clicked");
    previousTabRef.target = ref.target;
    setClick(false);
  };

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const handleScroll = () => {
    if(window.scrollY > 10) {
      setShowNavBarColor(true)
    } else {
      setShowNavBarColor(false)
    }
  }

  useEffect(() => {
    showButton();
    const fecthData = async () => {
      try {
        const navSectionData = await client.getEntry(process.env.REACT_APP_NAVIGATION_SECTION_ENTRY_ID);
        setNavigationBarData(navSectionData);
      } catch (error) {
        console.log("==Data not received", error);
      }
    };
    fecthData();

    window.addEventListener("resize", showButton);
    window.addEventListener("scroll", handleScroll)
    return () =>  {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", showButton);
    }
  }, []);


  return (
      <S.NavBar showBackgroundColor={showNavBarColor}>
        <S.NavBarContainer>
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <S.NavBarLogo
              src={navigationData.fields?.adharvaLogo?.fields?.file?.url || adharvaLogo}
              alt="adharva_logo_blue"
            />
          </Link>
          <S.MenuIcon onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </S.MenuIcon>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            {(
              navigationData.fields?.navigationBarSections?.sections ||
              NAVIGATION_LINKS
            ).map((eachSection, index) => {
              return (
                <S.NavItem key={index} ref={currentTabRef}>
                  <Link
                    to={eachSection.linkTo}
                    className="nav-links"
                    onClick={closeMobileMenu}
                  >
                    {eachSection.title.toUpperCase()}
                  </Link>
                </S.NavItem>
              );
            })}
          </ul>
          {button && (
            <Button buttonStyle="btn--outline" routeTo="/register">
              {navigationData.fields?.navigationBarSections?.button
                ?.buttonName || NAVIGATION_BAR_BUTTON}
            </Button>
          )}
        </S.NavBarContainer>
      </S.NavBar>
  );
}
